import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getCurrentAdminStatus } from "./auth";

export default function RequireAuth() {
  const [status, setStatus] = useState("loading");
  const location = useLocation();

  useEffect(() => {
    let active = true;

    async function checkAuth() {
      const result = await getCurrentAdminStatus();

      if (!active) return;

      if (!result.authenticated) {
        setStatus("unauthenticated");
      } else if (!result.isAdmin) {
        setStatus("forbidden");
      } else {
        setStatus("authorized");
      }
    }

    checkAuth();

    return () => {
      active = false;
    };
  }, []);

  if (status === "loading") return <div className="p-8">Checking authentication...</div>;

  if (status === "unauthenticated") {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  if (status === "forbidden") {
    return <div className="p-8">You do not have permission to access this page.</div>;
  }

  return <Outlet />;
}